<template>
    <div class="contenedor_escritorio">
        <div class="lateral_escritorio">

            <div class="cabecera_lateral_escritorio"
                :style="id_empresa_seleccionada == 1 ? 'background-color: #102578;' : ''">
                <img :src="BANNER_EMPRESA" alt="">
            </div>

            <div class="contenedor_btns_menu">

                <div v-if="permisos.inventarios?.ver || ES_ROOT" class="btn_menu"
                    :class="{ 'btn_menu_activo': modulo === 'inventario' }" @click="set_modulo('inventario')">
                    <div class="icono_menu">
                        <i class="fas fa-box"></i>
                    </div>
                    <div class="texto_menu">
                        Inventario
                    </div>
                </div>

                <div v-if="permisos.traslados?.ver || ES_ROOT" class="btn_menu"
                    :class="{ 'btn_menu_activo': modulo === 'traslados' }" @click="set_modulo('traslados')">
                    <div class="icono_menu">
                        <i class="fas fa-exchange-alt"></i>
                    </div>
                    <div class="texto_menu">
                        Traslados
                    </div>
                </div>

                <div v-if="permisos.sucursales?.ver || ES_ROOT" class="btn_menu"
                    :class="{ 'btn_menu_activo': modulo === 'sucursales' }" @click="set_modulo('sucursales')">
                    <div class="icono_menu">
                        <i class="fas fa-store"></i>
                    </div>
                    <div class="texto_menu">
                        Sucursales
                    </div>
                </div>

                <!-- <div v-if="permisos.marcas?.ver || ES_ROOT" class="btn_menu" @click="set_modulo('marcas')">
                    <div class="icono_menu">
                        <i class="fas fa-tag"></i>
                    </div>
                    <div class="texto_menu">
                        Marcas
                    </div>
                </div> -->

                <div v-if="permisos.proveedores?.ver || ES_ROOT" class="btn_menu"
                    :class="{ 'btn_menu_activo': modulo === 'proveedores' }" @click="set_modulo('proveedores')">
                    <div class="icono_menu">
                        <i class="fas fa-users"></i>
                    </div>
                    <div class="texto_menu">
                        Proveedores
                    </div>
                </div>

                <div v-if="permisos.registro_desperdicio?.ver || ES_ROOT" class="btn_menu"
                    :class="{ 'btn_menu_activo': modulo === 'merma' }" @click="set_modulo('merma')">
                    <div class="icono_menu">
                        <i class="far fa-trash-alt"></i>
                    </div>
                    <div class="texto_menu">
                        Registro desperdicio
                    </div>
                </div>

                <div v-if="permisos.solicitud_descuento?.ver || ES_ROOT" class="btn_menu"
                    :class="{ 'btn_menu_activo': modulo === 'descuentos' }" @click="set_modulo('descuentos')">
                    <div class="icono_menu">
                        <i class="fas fa-percent"></i>
                    </div>
                    <div class="texto_menu">
                        S. de descuento
                    </div>
                </div>

                <div v-if="permisos.anulacion_de_factura?.ver || ES_ROOT" class="btn_menu"
                    :class="{ 'btn_menu_activo': modulo === 'anulaciones' }" @click="set_modulo('anulaciones')">
                    <div class="icono_menu">
                        <i class="fas fa-ban"></i>
                    </div>
                    <div class="texto_menu">
                        Anulación de Fac.
                    </div>
                </div>

                <div v-if="permisos.solicitudes_de_anulacion?.ver || ES_ROOT" class="btn_menu"
                    :class="{ 'btn_menu_activo': modulo === 'solicitud_de_anulacion' }"
                    @click="set_modulo('solicitud_de_anulacion')">
                    <div class="icono_menu">
                        <i class="fas fa-question"></i>
                    </div>
                    <div class="texto_menu">
                        S. de Anulación
                    </div>
                </div>

                <div v-if="permisos.configuracion?.ver || ES_ROOT" class="btn_menu"
                    :class="{ 'btn_menu_activo': modulo === 'configuracion' }" @click="set_modulo('configuracion')">
                    <div class="icono_menu">
                        <i class="fas fa-cog"></i>
                    </div>
                    <div class="texto_menu">
                        Configuración
                    </div>
                </div>

                <div v-if="permisos.depositos?.ver || ES_ROOT" class="btn_menu"
                    :class="{ 'btn_menu_activo': modulo === 'depositos' }" @click="set_modulo('depositos')">
                    <div class="icono_menu">
                        <i class="fas fa-piggy-bank"></i>
                    </div>
                    <div class="texto_menu">
                        Depósitos
                    </div>
                </div>

                <div v-if="permisos.anticipos?.ver || ES_ROOT" class="btn_menu"
                    :class="{ 'btn_menu_activo': modulo === 'anticipos' }" @click="set_modulo('anticipos')">
                    <div class="icono_menu">
                        <i class="fas fa-clock"></i>
                    </div>
                    <div class="texto_menu">
                        Anticipos
                    </div>
                </div>

            </div>
            <div class="contenedor_datos_usuario">
                <div class="nombre_usuario">
                    <div class="icono_info_datos_usuario">
                        <i class="fas fa-user"></i>
                    </div>
                    <div class="texto_info_datos_usuario">
                        {{ datos_usuario.nombre_completo }}
                    </div>
                </div>
                <div class="nombre_usuario">
                    <div class="icono_info_datos_usuario">
                        <i class="far fa-id-badge"></i>
                    </div>
                    <div class="texto_info_datos_usuario">
                        {{ datos_usuario.id }}
                    </div>
                </div>
                <div class="nombre_usuario">
                    <div class="icono_info_datos_usuario">
                        <i class="fas fa-store"></i>
                    </div>
                    <div class="texto_info_datos_usuario">
                        {{ datos_usuario.sucursal_asignada }}
                    </div>
                </div>
                <div class="nombre_usuario">
                    <div class="icono_info_datos_usuario">
                        <i class="fas fa-building"></i>
                    </div>
                    <div class="texto_info_datos_usuario">
                        {{ id_empresa_seleccionada }}
                    </div>
                </div>
            </div>
            <div v-if="permisos.facturador?.ver || ES_ROOT" class="btn_facturador">
                <button type="button" class="btn btn-sm btn-outline-dark btn-block" @click="if_facturador"><i
                        class="fas fa-cash-register"></i> Ir al
                    Facturador</button>
            </div>
            <div class="contenedor_btn_cambiar_empresa">
                <button type="button" class="btn btn-sm btn-outline-dark btn-block" @click="cambiar_empresa"><i
                        class="fas fa-exchange-alt"></i> Cambiar
                    empresa</button>
            </div>
            <div class="contenedor_btn_cerrar_sesion">
                <button type="button" class="btn btn-sm btn-danger btn-block" @click="cerrar_sesion">Salir</button>
            </div>
        </div>
        <div class="contenido_escritorio">

            <Inventario v-if="modulo == 'inventario'" />
            <Sucursales v-if="modulo == 'sucursales'" />
            <!-- <Marcas v-if="modulo == 'marcas'" /> -->
            <Proveedores v-if="modulo == 'proveedores'" />
            <Traslados v-if="modulo == 'traslados'" />
            <Merma v-if="modulo == 'merma'" />
            <Descuentos v-if="modulo == 'descuentos'" />
            <Anulaciones v-if="modulo == 'anulaciones'" />
            <SolicitudesDeAnulacion v-if="modulo == 'solicitud_de_anulacion'" />
            <Configuracion v-if="modulo == 'configuracion'" />
            <Depositos v-if="modulo == 'depositos'" />
            <Anticipos v-if="modulo == 'anticipos'" />
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapState } from 'vuex'

    import Inventario from '../components/Inventario/Menu.vue'
    import Sucursales from '../components/Sucursales/Menu.vue'
    // import Marcas from '../components/Marcas/Menu.vue'
    import Proveedores from '../components/Proveedores/Menu.vue'
    import Traslados from '../components/Traslados/Menu.vue'
    import Merma from '../components/Merma/Menu.vue'
    import Descuentos from '../components/Descuentos/Menu.vue'
    import Anulaciones from '../components/Anulaciones/Menu.vue'
    import SolicitudesDeAnulacion from '../components/Anulaciones/SolicitudesDeAnulacion.vue'
    import Configuracion from '../components/Configuracion/Menu.vue'
    import Depositos from '../components/Depositos/Menu.vue'
    import Anticipos from '../components/Anticipos/Menu.vue'

    export default {
        name: 'Escritorio',
        computed: {
            ...mapState(['_socket', 'permisos', 'datos_usuario', 'id_empresa_seleccionada']),
            ...mapGetters(['ES_ROOT', 'BANNER_EMPRESA'])
        },
        components: {
            Inventario,
            Sucursales,
            // Marcas,
            Proveedores,
            Traslados,
            Merma,
            Descuentos,
            Anulaciones,
            SolicitudesDeAnulacion,
            Configuracion,
            Depositos,
            Anticipos
        },
        data() {
            return {
                modulo: 'inventario'
            }
        },
        methods: {
            set_modulo(modulo) {
                this.modulo = modulo
            },
            cambiar_empresa() {
                this.$router.push('empresas')
            },
            if_facturador() {
                this.$router.push('facturador')
            },
            ...mapActions([
                'cerrar_sesion',
                'obtener_sucursales',
                'obtener_unidades',
                'obtener_marcas',
                'obtener_datos_usuario',
                'obtener_proveedores',
                'obtener_articulos',
                'obtener_materiales',
                'obtener_correlativos',
                'obtener_maquinas',
                'obtener_tipos_de_rollo',
                'validar_seleccion_empresa',
                'iniciar_conexion',
                'descargar_datos',
                'obtener_permisos'
            ])
        },
        async mounted() {
            let validacion = await this.validar_seleccion_empresa()
            if (validacion) {

                if (this._socket == false) this.iniciar_conexion()


                await this.obtener_sucursales()
                await this.obtener_unidades()
                await this.obtener_marcas()
                await this.obtener_datos_usuario()
                await this.obtener_proveedores()
                await this.obtener_articulos()
                await this.obtener_materiales()
                await this.obtener_correlativos()
                await this.obtener_maquinas()
                await this.obtener_tipos_de_rollo()
                // await this.descargar_datos()
                await this.obtener_permisos()
            }
        },
    }
</script>

<style>
    .contenedor_escritorio {
        width: 100%;
        height: 100vh;
        display: flex;
    }

    .lateral_escritorio {
        width: 230px;
        height: 100vh;
        background-color: #f8f8fe;
        position: relative;
    }

    .cabecera_lateral_escritorio {
        width: 100%;
        height: 50px;
        margin-bottom: 10px;
        border: 1px solid #e5e5ea;

    }

    .cabecera_lateral_escritorio img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        /* background-color: #102578; */
    }

    .contenedor_btns_menu {
        width: 100%;
        height: auto;
        padding-left: 5px;
        padding-right: 5px;
    }

    .btn_menu {
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        transition: .4s ease;
        cursor: pointer;
        user-select: none;
        border-radius: 4px;
    }

    .btn_menu_activo {
        background-color: #5a5858;
        color: white;
    }

    .btn_menu_activo .icono_menu,
    .btn_menu_activo .texto_menu {
        color: white;
    }

    .btn_menu:hover {
        background-color: #e5e5ea;
    }

    .icono_menu {
        width: 30px;
        height: 30px;
        margin-right: 10px;
        margin-left: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #3a383f;
        font-size: 18px;
    }

    .texto_menu {
        width: calc(100% - 50px);
        color: #3a383f;
        font-size: 18px;
    }

    .contenedor_btn_cerrar_sesion {
        width: 100%;
        height: auto;

        position: absolute;
        bottom: 0;
        left: 0;
        padding: 5px;

    }

    .contenedor_btn_cambiar_empresa {
        width: 100%;
        height: auto;
        position: absolute;
        bottom: 40px;
        left: 0;
        padding: 5px;
    }

    .btn_facturador {
        width: 100%;
        height: auto;
        position: absolute;
        bottom: 80px;
        left: 0;
        padding: 5px;
    }

    .btn_pdf {
        width: 100%;
        height: auto;
        position: absolute;
        bottom: 120px;
        left: 0;
        padding: 5px;
    }

    .contenido_escritorio {
        width: calc(100% - 230px);
        height: 100%;
    }


    /* estilos componentes */

    .contenedor_contenido {
        width: 100%;
        height: 100%;
    }

    .cabecera_contenido {
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #e5e5ea;
        display: flex;
    }

    .contenido_ {
        width: 100%;
        height: calc(100% - 40px);
    }

    /* modal */

    .contenedor_modal {
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 999;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .contenedor_modal_cuerpo {
        width: 700px;
        height: auto;
        background-color: white;
        border-radius: 5px;
    }

    .contenedor_modal_cabecera {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 10px;
        border-bottom: 1px solid #e5e5ea;
    }

    /* Modal completo */

    .contenedor_modal_completo {
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        background-color: white;
    }

    .contenedor_modal_completo_cabecera {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 10px;
        border-bottom: 1px solid #e5e5ea;
    }

    .contenedor_modal_completo_contenido {
        width: 100%;
        height: calc(100% - 40px);
    }


    /* estilos btns contextuales */

    .btn_menu_contextual {
        width: 150px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #D1D1D1;
        margin-right: 2px;
        color: #ffffff;
        cursor: pointer;
        user-select: none;
        transition: .4s ease;
    }

    .btn_menu_contextual:hover {
        background-color: #FF9D01;
        color: white;
    }

    .btn_crear_agregar {
        width: 45px;
        height: 45px;
        position: fixed;
        bottom: 10px;
        right: 10px;
        border-radius: 50%;
        background-color: orangered;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
        transition: .4s ease;
    }

    .btn_crear_agregar:hover {
        background-color: #FF9D01;
    }

    /* SPINNER */

    .contenedor_spinner {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 0;
        right: 0;
    }

    .contenedor_spinner img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .contenedor_datos_usuario {
        width: 100%;
        font-size: 13px;
        position: absolute;
        bottom: 120px;
        left: 0;
        padding: 5px;
    }

    .nombre_usuario {
        display: flex;
    }

    .texto_info_datos_usuario {
        display: flex;
        align-items: center;
        margin-left: 5px;
    }

    .icono_info_datos_usuario {
        width: 25px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>